import { Injectable } from "@angular/core";
import { config } from "config/environment";
import { ENVS } from "config/envs";

@Injectable({
	providedIn: "root"
})
export class ShowcaseService {
	public isStaging(): boolean {
		return config.envName === ENVS.STAGING || config.envName === ENVS.LOCAL;
	}
}
